import convertTagsStringToArray from './convert-tags-string-to-array';

import {
  MultilingualText,
  MultiLingualTags,
  Tag,
  WorksList
} from '../../../../shared/types/work';

export const getAllWorksTags = (works: WorksList): MultiLingualTags | null => {
  const worksWithTags = works?.filter(work => Boolean(work.tags));

  if (!worksWithTags) {
    return null;
  }

  let allMultiLingualTags = [] as MultiLingualTags;

  worksWithTags.forEach(workWithTag => {
    // Converts the german tags from this work entry from string to an array and removes empty tags
    const germanTags = workWithTag.tags.de;
    const germanTagsList = convertTagsStringToArray(germanTags)?.filter(
      germanTag => germanTag !== ''
    );

    if (!germanTagsList) {
      return;
    }

    // Converts the english tags from this work entry from string to an array and removes empty tags
    const englishTags = workWithTag.tags.en;
    const englishTagsList = convertTagsStringToArray(englishTags)?.filter(
      englishTag => englishTag !== ''
    );

    const multiLingualTagValues = germanTagsList?.map((tag: Tag, index) => {
      if (englishTagsList) {
        return {
          de: tag,
          en: englishTagsList[index] ? englishTagsList[index] : ''
        } as MultilingualText;
      }

      return {
        de: tag,
        en: ''
      } as MultilingualText;
    });

    // Adds the tags to all tags
    allMultiLingualTags = allMultiLingualTags.concat(multiLingualTagValues);
  });

  return allMultiLingualTags;
};
